"use strict";
var bar_component_1 = require('./progressbar/bar.component');
exports.BarComponent = bar_component_1.BarComponent;
var progress_directive_1 = require('./progressbar/progress.directive');
exports.ProgressDirective = progress_directive_1.ProgressDirective;
var progressbar_component_1 = require('./progressbar/progressbar.component');
exports.ProgressbarComponent = progressbar_component_1.ProgressbarComponent;
var progressbar_module_1 = require('./progressbar/progressbar.module');
exports.ProgressbarModule = progressbar_module_1.ProgressbarModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/components/progressbar.js
// module id = 1098
// module chunks = 3